import { useQuery } from '@tanstack/react-query';
import { queryClient } from '@/utils/trpc';
import { useAuth } from '@/routes/AuthContext';
import {
  resolveMfaSetupGuard,
  type MfaSetupGuardResult,
} from '../utils/resolveMfaSetupGuard';

export const MFA_SETUP_GUARD_QUERY_KEY = ['mfaSetupGuard'] as const;

const MFA_SETUP_GUARD_STALE_TIME_MS = 5 * 60 * 1000;

export const mfaSetupGuardQueryOptions = (email: string) => ({
  queryKey: [...MFA_SETUP_GUARD_QUERY_KEY, email] as const,
  queryFn: () => resolveMfaSetupGuard(email),
  staleTime: MFA_SETUP_GUARD_STALE_TIME_MS,
});

export const fetchMfaSetupGuard = (
  email: string,
): Promise<MfaSetupGuardResult> =>
  queryClient.fetchQuery(mfaSetupGuardQueryOptions(email));

export const useMfaSetupGuard = (email: string | undefined) => {
  const { isAuthenticated, isLoading: authLoading } = useAuth();

  return useQuery({
    ...mfaSetupGuardQueryOptions(email ?? ''),
    enabled: isAuthenticated && !!email && !authLoading,
  });
};

export const invalidateMfaSetupGuard = (email?: string) =>
  queryClient.invalidateQueries({
    queryKey: email
      ? [...MFA_SETUP_GUARD_QUERY_KEY, email]
      : MFA_SETUP_GUARD_QUERY_KEY,
  });
